import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledEmbedPricing = styled.div`
	min-height: 800px;

	&.widget-mode {
		margin-top: -500px;
	}

	iframe {
		width: 100% !important;
		min-height: 880px !important;
	}
`;

export const StyledPricing = styled.section`
	color: ${CSSVars.gray900};
	text-align: center;
	background: linear-gradient(255.96deg, #7d93ed 0%, #3047a6 100%);
	min-height: 600px;
	padding: 10px 20px 50px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 20px 40px 100px;
	}
`;
